if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
      this.useSuccessMessage = this.cart && this.cart.tagName.toLowerCase() !== 'cart-notification';
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
      
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.error = false; // ✅ Inicializar siempre en false
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // ✅ CRÍTICO: Resetear error al inicio
      this.error = false;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }
      
      config.body = formData;

      // ✅ Usar window.routes para asegurar que esté disponible
      const cartAddUrl = window.routes?.cart_add_url || '/cart/add';

      fetch(cartAddUrl, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // Error del servidor (producto agotado, etc.)
            document.dispatchEvent(new CustomEvent('afterAddCartError', {
              detail: {
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message
              }
            }));
            
            this.handleErrorMessage(response.description);
            
            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              const buttonSpan = this.submitButton.querySelector('span');
              if (buttonSpan) buttonSpan.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            
            this.error = true;
            return;
          }
          
          if (!this.cart) {
            // Redirigir al carrito si no hay drawer/notification
            window.location = window.routes?.cart_url || '/cart';
            return;
          }

          // ✅ ÉXITO
          if (this.useSuccessMessage && typeof pushSuccessMessage === 'function') {
            pushSuccessMessage(window.cartStrings?.success || 'Producto agregado al carrito');
          }
          
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) {
            document.body.addEventListener('drawerClosed', () => {
              setTimeout(() => {
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  this.cart.renderContents(response);
                }
              });
            }, { once: true });
            
            if (typeof quickAddDrawer.close === 'function') {
              quickAddDrawer.close();
            }
          } else if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(response);
          }
          
          document.dispatchEvent(new CustomEvent('afterCartChanged', {
            detail: {
              productVariantId: formData.get('id'),
              source: 'product-form',
              cartData: response
            }
          }));
        })
        .catch((e) => {
          console.error('Error adding to cart:', e);
          this.error = true;
          
          const errorMsg = window.cartStrings?.error || 'Error al agregar al carrito';
          if (typeof pushErrorMessage === 'function') {
            pushErrorMessage(errorMsg);
          } else {
            this.handleErrorMessage(errorMsg);
          }
        })
        .finally(() => {
          // ✅ SIEMPRE limpiar estado
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
          }
          
          if (this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          
          if (spinner) spinner.classList.add('hidden');
        });
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;

      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text && this.submitButtonText) {
          this.submitButtonText.textContent = text;
        }
      } else {
        this.submitButton.removeAttribute('disabled');
        if (this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Agregar al carrito';
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      
      if (errorMessage && !this.errorMessageWrapper && typeof pushErrorMessage === 'function') {
        pushErrorMessage(errorMessage);
      }
      
      if (!this.errorMessageWrapper) return;
      
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}